import React from 'react';
import logo from '../assets/images/logo.png';

function Logo() {
  return <img src={logo} alt='Jobs Manager' width='50px' className='logo' />;
}

export default Logo;
